import type { SceneBuilder } from "../../reel/scenes.js";
import { brandBackdrop } from "../../primitives/brandBackdrop.js";
import {
  clipFrame, clipOutroFade, combineSceneFragments, makeTl, typeSize, weights, withAlpha,
  colors as themeColors, escapeHtml, gsapSetLine, accentFor,
} from "../../reel/sceneShared.js";

export const quoteSlam: SceneBuilder = ({ ctx, clipPrefix, inputs, clipDurationSec, clipStartSec }) => {
  const text = inputs.text ?? "";
  const author = inputs.subtext ?? "";
  const accent = accentFor(inputs);
  const xl = typeSize("xl", ctx.format);
  const md = typeSize("md", ctx.format);
  const t = makeTl(clipStartSec);
  const qId = `${clipPrefix}-q`;
  const hId = `${clipPrefix}-h`;
  const aId = `${clipPrefix}-a`;

  const backdrop = brandBackdrop(ctx, `${clipPrefix}-bg`, { variant: "noise", accent });

  const inner = `<div id="${qId}" aria-hidden="true" style="font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${xl * 2}px;color:${withAlpha(themeColors.primary, 0.25)};line-height:.8;">"</div>
<h1 id="${hId}" style="margin:0;font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${xl}px;line-height:1.05;letter-spacing:-2px;color:${themeColors.fg};text-align:center;text-wrap:balance;max-width:${ctx.format === "9:16" ? 880 : 1400}px;">${escapeHtml(text)}</h1>
${author ? `<div id="${aId}" style="font-family:'Inter',sans-serif;font-weight:${weights.semibold};font-size:${md}px;letter-spacing:-0.4px;color:${withAlpha(themeColors.fg, 0.85)};text-align:center;">— ${escapeHtml(author)}</div>` : ""}`;

  const html = clipFrame({ clipPrefix, clipStartSec, clipDurationSec, inner, gapPx: 40 });

  const init = [
    gsapSetLine(`#${qId}`, { opacity: 0, y: -50 }),
    gsapSetLine(`#${hId}`, { opacity: 0, y: -100 }),
    author ? gsapSetLine(`#${aId}`, { opacity: 0, y: 12 }) : "",
  ].filter(Boolean).join("\n");

  const tweens = [
    t.to(`#${qId}`, { opacity: 1, y: 0, duration: 0.73, ease: "raw:\"back.out(1.4)\"" }, 0),
    t.to(`#${hId}`, { opacity: 1, y: 0, duration: 0.73, ease: "raw:\"back.out(1.4)\"" }, 0),
  ];
  if (author) tweens.push(t.to(`#${aId}`, { opacity: 1, y: 0, duration: 0.53, ease: "raw:\"power1.out\"" }, 16 / 30));
  tweens.push(clipOutroFade(clipPrefix, clipDurationSec, clipStartSec));

  return combineSceneFragments([backdrop, { html, init, tweens }]);
};
